import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiBook, FiTarget, FiTrendingUp, FiArrowRight} = FiIcons;

const WelcomePage = ({ onStart }) => {
  return (
    <div className="text-center max-w-3xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="mb-8"
      >
        <div className="flex justify-center mb-6">
          <div className="bg-gradient-to-r from-blue-600 to-orange-500 p-4 rounded-full">
            <SafeIcon icon={FiBook} className="text-4xl text-white" />
          </div>
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
          <span className="text-blue-600">GospelWise</span>{' '}
          <span className="text-orange-500 italic">Author™</span>
        </h1>
        
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 mb-6">
          Marketing Starter Guide
        </h2>
        
        <p className="text-xl text-gray-600 mb-8 leading-relaxed">
          Market Your Book in 15 Minutes with 4 Simple Steps
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="bg-white rounded-2xl shadow-xl p-8 mb-8"
      >
        <h3 className="text-2xl font-bold text-gray-800 mb-6">
          Feeling stuck or unsure how to market your book?
        </h3>
        
        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
          In just 15 minutes, this GospelWise mini-app will help you define your message, 
          set clear goals, pick the right strategies, and take your next faithful step—without the stress.
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-blue-50 p-4 rounded-xl"
          >
            <SafeIcon icon={FiTarget} className="text-2xl text-blue-600 mb-2 mx-auto" />
            <h4 className="font-semibold text-gray-800 mb-1 text-sm">Step 1</h4>
            <p className="text-xs text-gray-600">Define Mission & Reader</p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-purple-50 p-4 rounded-xl"
          >
            <SafeIcon icon={FiTarget} className="text-2xl text-purple-600 mb-2 mx-auto" />
            <h4 className="font-semibold text-gray-800 mb-1 text-sm">Step 2</h4>
            <p className="text-xs text-gray-600">Set Launch Goals</p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-orange-50 p-4 rounded-xl"
          >
            <SafeIcon icon={FiTrendingUp} className="text-2xl text-orange-600 mb-2 mx-auto" />
            <h4 className="font-semibold text-gray-800 mb-1 text-sm">Step 3</h4>
            <p className="text-xs text-gray-600">Choose Strategy</p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-green-50 p-4 rounded-xl"
          >
            <SafeIcon icon={FiArrowRight} className="text-2xl text-green-600 mb-2 mx-auto" />
            <h4 className="font-semibold text-gray-800 mb-1 text-sm">Step 4</h4>
            <p className="text-xs text-gray-600">Take First Action</p>
          </motion.div>
        </div>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onStart}
          className="bg-gradient-to-r from-blue-600 to-orange-500 text-white px-8 py-4 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 flex items-center mx-auto"
        >
          Let's Get Started!
          <SafeIcon icon={FiArrowRight} className="ml-2" />
        </motion.button>

        <p className="text-sm text-gray-500 mt-4">
          Take a deep breath. Grab a cup of coffee. Let's go!
        </p>
      </motion.div>
    </div>
  );
};

export default WelcomePage;